import React from 'react';

const LawyerBenefits: React.FC = () => {
  const benefits = [
    {
      title: '共有者との交渉を代行できる',
      icon: 'ri-discuss-line',
      description: '感情的な対立がある場合でも、弁護士が第三者として冷静に交渉を進めます。',
      details: [
        '法的根拠を示しながら説得力のある交渉',
        '感情的な対立を避け、冷静な話し合いを実現',
        '連絡が取れない共有者への対応',
        '不在者財産管理人の選任申立て'
      ]
    },
    {
      title: '遺産分割協議をまとめられる',
      icon: 'ri-file-list-3-line',
      description: '相続登記が終わっていない場合、遺産分割協議から対応します。',
      details: [
        '相続人の確定と戸籍調査',
        '遺産の調査と評価',
        '遺産分割協議書の作成',
        '相続登記の手続き（司法書士と連携）'
      ]
    },
    {
      title: '共有物分割請求の手続きを任せられる',
      icon: 'ri-scales-3-line',
      description: '話し合いがまとまらない場合、裁判所を通じた手続きを代行します。',
      details: [
        '共有物分割請求訴訟の提起',
        '裁判所での主張・立証',
        '分割方法の提案（現物分割・代償分割・競売）',
        '判決後の執行手続き'
      ]
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            弁護士に依頼するメリット
          </h2>
          <p className="text-xl text-gray-600">
            不動産会社ではできない、弁護士だからこそできること
          </p>
        </div>

        <div className="max-w-6xl mx-auto space-y-8">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-orange-50 to-white rounded-2xl p-8 border-2 border-orange-200 hover:shadow-xl transition-all duration-200"
            >
              <div className="flex items-start mb-6">
                <div className="w-16 h-16 bg-orange-500 rounded-xl flex items-center justify-center flex-shrink-0 mr-6">
                  <i className={`${benefit.icon} text-3xl text-white`}></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-700 text-lg leading-relaxed">
                    {benefit.description}
                  </p>
                </div>
              </div>

              <div className="ml-0 md:ml-22 bg-white rounded-lg p-6 border border-gray-200">
                <h4 className="font-bold text-gray-900 mb-4 flex items-center">
                  <i className="ri-check-double-line text-orange-500 mr-2"></i>
                  具体的なサポート内容
                </h4>
                <div className="grid md:grid-cols-2 gap-3">
                  {benefit.details.map((detail, idx) => (
                    <div key={idx} className="flex items-start">
                      <span className="text-orange-500 mr-2 mt-1">✓</span>
                      <span className="text-gray-700">{detail}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          <div className="bg-gray-50 rounded-xl p-8 border-2 border-gray-200">
            <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
              <i className="ri-close-circle-line text-red-500 text-2xl mr-3"></i>
              不動産会社では対応できないこと
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start text-gray-700">
                <span className="text-red-500 mr-2 mt-1">✗</span>
                <span>共有者との法的交渉</span>
              </li>
              <li className="flex items-start text-gray-700">
                <span className="text-red-500 mr-2 mt-1">✗</span>
                <span>遺産分割協議のサポート</span>
              </li>
              <li className="flex items-start text-gray-700">
                <span className="text-red-500 mr-2 mt-1">✗</span>
                <span>裁判所への訴訟提起</span>
              </li>
              <li className="flex items-start text-gray-700">
                <span className="text-red-500 mr-2 mt-1">✗</span>
                <span>不在者財産管理人の選任申立て</span>
              </li>
            </ul>
          </div>

          <div className="bg-orange-50 rounded-xl p-8 border-2 border-orange-200">
            <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
              <i className="ri-check-double-line text-orange-500 text-2xl mr-3"></i>
              弁護士だからできること
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start text-gray-700">
                <span className="text-orange-500 mr-2 mt-1">✓</span>
                <span>法的根拠を示した交渉</span>
              </li>
              <li className="flex items-start text-gray-700">
                <span className="text-orange-500 mr-2 mt-1">✓</span>
                <span>遺産分割協議書の作成</span>
              </li>
              <li className="flex items-start text-gray-700">
                <span className="text-orange-500 mr-2 mt-1">✓</span>
                <span>共有物分割請求訴訟の代理</span>
              </li>
              <li className="flex items-start text-gray-700">
                <span className="text-orange-500 mr-2 mt-1">✓</span>
                <span>複雑な法的手続きの一貫対応</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LawyerBenefits;
